import { render, staticRenderFns } from "./CoreProgramCampaignStep4ListTemplate.vue?vue&type=template&id=15e43c5c&scoped=true&"
import script from "./CoreProgramCampaignStep4ListTemplate.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignStep4ListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CoreProgramCampaignStep4ListTemplate.vue?vue&type=style&index=0&id=15e43c5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e43c5c",
  null
  
)

export default component.exports